import React from 'react';
import {Link} from 'react-router';
import {
  ROUTE_CONTACT, ROUTE_FRIENDS, ROUTE_HIRING, ROUTE_HOME, ROUTE_INTRODUCTION, ROUTE_MEDIA,
  ROUTE_PERFORMANCES, URL_FACEBOOK, URL_SOUNDCLOUD, URL_TWITTER
} from '../constants'

function Footer() {

return (
  <footer className="page-footer">
    <div className="container">
      <div className="row">
        <div className="col l5 s12">
          <h5 className="white-text">Mouv' your Baudet</h5>
          <p className="white-text text-lighten-4">12 impasse Olivier de Serres<br/>86000 POITIERS</p>
          <p className="white-text text-lighten-4"><a className="white-text text-lighten-3" href="tel:+33621570943">Tél : 06.21.57.09.43</a>
            <br/><a className="white-text text-lighten-3" href="mailto:mouvyourbaudet@gmail.com">E-mail : mouvyourbaudet@gmail.com</a></p>
          <p>
            <Link activeClassName={'active'} to={ROUTE_CONTACT} className="waves-effect waves-light btn orange-button"><i className="material-icons left">email</i>Nous contacter</Link>
          </p>
        </div>

        <div className="col l4 s12">
          <h5 className="white-text">Plan du site</h5>
          <p>
            <Link className="white-text text-lighten-3" to={ROUTE_HOME}>Accueil</Link><br/>
            <Link className="white-text text-lighten-3" to={ROUTE_INTRODUCTION}>Présentation</Link><br/>
            <Link className="white-text text-lighten-3" to={ROUTE_PERFORMANCES}>Prestations</Link><br/>
            <Link className="white-text text-lighten-3" to={ROUTE_MEDIA}>Médias</Link><br/>
            <Link className="white-text text-lighten-3" to={ROUTE_FRIENDS}>Amis</Link><br/>
            <Link className="white-text text-lighten-3" to={ROUTE_HIRING}>Recrutement</Link><br/>
            <Link className="white-text text-lighten-3" to={ROUTE_CONTACT}>Contact</Link><br/>
          </p>
        </div>

        <div className="col l3 s12">
          <h5 className="white-text">Réseaux sociaux</h5>
          <p><a className="white-text text-lighten-3 waves-effect waves-light btn facebook-button" href={URL_FACEBOOK} target="_blank" rel="noopener"><i className="material-icons left">thumb_up</i>Facebook</a></p>
          <p><a className="white-text text-lighten-3 waves-effect waves-light btn twitter-button" href={URL_TWITTER} target="_blank" rel="noopener"><i className="material-icons left">repeat</i>Twitter</a></p>
          <p><a className="white-text text-lighten-3 waves-effect waves-light btn soundcloud-button" href={URL_SOUNDCLOUD} target="_blank" rel="noopener"><i className="material-icons left">cloud</i>Soundcloud</a></p>


        </div>

      </div>
    </div>
    <div className="footer-copyright">
      <div className="container">
        © 2009-{new Date().getFullYear()} Mouv' your Baudet
      </div>
    </div>
  </footer>
  )

}

export default Footer




/** WEBPACK FOOTER **
 ** ./src/components/Footer.js
 **/